import * as CryptoJS from 'crypto-js'

/**
 * @param {File | null} file
 * @return {Promise<string>}
 */
function read (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = function () {
      if (reader.result) {
        resolve(reader.result)
      } else {
        reject(new Error())
      }
    }
    reader.onerror = function () {
      reject(new Error())
    }
    reader.readAsBinaryString(file)
  })
}

function post (data, url, heders) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.responseType = 'json'
    xhr.onload = function () {
      if (xhr.status !== 200) {
        reject(new Error(`${xhr.status}: ${xhr.statusText}`))
      } else {
        resolve(xhr.response)
      }
    }
    xhr.onerror = function () {
      reject(new Error())
    }
    xhr.open('POST', url)
    Object.entries(heders).forEach(([name, value]) => {
      console.log(name)
      console.log(value)
      xhr.setRequestHeader(name, value)
    })
    xhr.send(data)
  })
}

export default async function (token, url, file) {
  const data = await read(file)
  const hash = CryptoJS.SHA1(CryptoJS.enc.Latin1.parse(data)).toString()
  console.log(hash)
  return post(file, url, {
    'Content-Type': file.type,
    'Authorization': token,
    'X-Bz-File-Name': file.name,
    'X-Bz-Content-Sha1': hash
  })
}
